import React from 'react'
import clientImage from "../static/images/icon-image/author.jpg"

const Testimonial = () => (
   <section id="testimonial" className="main-container bg-ash">
  <div className="container">
    <div className="row">
      <div className="col text-center">
        <div className="section-heading">
          <h2>
            <small>Client’s Love</small>
            Love from <span>Client</span>
          </h2>
          <span className="animate-border ml-auto mr-auto tw-mt-20 tw-mb-40" />
        </div>
      </div>
      {/* COl End */}
    </div>
    {/* Row End */}
    <div className="row justify-content-center">
      <div className="col-md-8 text-center">
        <div className="testimonial-slider owl-carousel">
          <div className="testimonial-content">
            <div className="testimonial-image">
              <img src= {clientImage} alt="client-image" />
            </div>
            <div className="testimonial-meta">
              <h4>
              Kyle S.
                {/* <small>CEO Microhost</small> */}
              </h4>
              <i className="icon icon-quote2" />
            </div>
            {/* Testimonial Meta end */}
            <div className="testimonial-text">
              <p>Wireless Whiz has an excellent service. I went to them to get my earpiece speaker fixed, I was quite impressed and happy as they fixed it, cleaned it and had it running again in 30 mins. Excellent staff. Definitely recommend.</p>
            </div>
           
          </div>
         
          <div className="testimonial-content">
            <div className="testimonial-image">
              <img src= {clientImage} alt="client-image" />
            </div>
            <div className="testimonial-meta">
              <h4>
              James Fowler
                {/* <small>CEO Microhost</small> */}
              </h4>
              <i className="icon icon-quote2" />
            </div>
            {/* Testimonial Meta end */}
            <div className="testimonial-text">
              <p>This is hands down the best place to get your cell phone fixed in Hamilton. These guys really know what they are doing and it was great to do business with them. </p>
            </div>
            {/* TEstimonial text end */}
          </div>
          {/* Testimonial Content End */}
          <div className="testimonial-content">
            <div className="testimonial-image">
              <img src= {clientImage} alt="client-image" />
            </div>
            <div className="testimonial-meta">
              <h4>
              Cathy Galus
                {/* <small>CEO Microhost</small> */}
              </h4>
              <i className="icon icon-quote2" />
            </div>
            {/* Testimonial Meta end */}
            <div className="testimonial-text">
              <p>Highly recommend Wireless Whiz for any type of repairs regarding cell phones or laptops of any brand. Staff was very knowledgeable, helpful, honest and friendly. Highly recommend.</p>
            </div>
            {/* TEstimonial text end */}
          </div>
          {/* Testimonial Content End */}

          <div className="testimonial-content">
            <div className="testimonial-image">
              <img src= {clientImage} alt="client-image" />
            </div>
            <div className="testimonial-meta">
              <h4>
              Daniel McClory
                {/* <small>CEO Microhost</small> */}
              </h4>
              <i className="icon icon-quote2" />
            </div>
            {/* Testimonial Meta end */}
            <div className="testimonial-text">
              <p>These guys are experts in their field, very resourceful THE BEST customer service for phone repair. They were able to fix my phone at less charge than anywhere in the mall and did it in 30 minutes! Highly recommend and will continue to support them.</p>
            </div>
            {/* TEstimonial text end */}
          </div>
        </div>
        {/* Carousel End */}
      </div>
      {/* COl End */}
    </div>
    {/* Row End */}
  </div>
  {/* Container End */}
</section>

)

export default Testimonial